import { BILLING_URL } from "@/lib/api";

/**
 * Panel yang muncul saat Google menolak request karena kredit habis.
 *
 * Sebelumnya error ini hanya jadi toast biasa berisi kalimat teknis, jadi
 * pengguna tidak punya jalan keluar dari aplikasi. Padahal ini masalah yang
 * bisa mereka selesaikan sendiri dalam satu klik, dan hanya mereka yang boleh
 * mengisinya karena involve kartu dan tagihan.
 */
export default function BillingAlert({ onClose }) {
  return (
    <div
      role="alert"
      data-testid="billing-alert"
      className="border-2 border-amber-500 bg-amber-50 p-4 sm:p-5"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="text-[14px] font-semibold text-amber-900">
            Project Google kamu belum bisa dipakai untuk generate
          </h3>
          <p className="mt-1.5 text-[12px] leading-relaxed text-amber-900/80">
            Generate image di Gemini tidak termasuk free tier, jadi project Google
            kamu wajib terhubung ke billing. Ini berlaku juga untuk project yang
            statusnya masih free tier — free tier itu hanya untuk model teks.
            Saldo dan tagihannya milik project Google kamu sendiri, bukan ke
            pemilik aplikasi.
          </p>
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Tutup"
            className="shrink-0 border border-amber-500 px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-amber-800 hover:bg-amber-100"
          >
            Tutup
          </button>
        )}
      </div>

      <a
        href={BILLING_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="billing-topup-link"
        className="mt-4 inline-flex items-center gap-2 border-2 border-amber-600 bg-amber-600 px-4 py-2.5 text-[13px] font-semibold text-white hover:bg-amber-700"
      >
        Aktifkan billing di AI Studio
        <span aria-hidden="true">&rarr;</span>
      </a>

      <p className="mt-3 text-[11px] leading-relaxed text-amber-900/70">
        Di halaman itu pilih project yang kamu pakai, lalu hubungkan ke billing
        account (Google Cloud Console &gt; Billing). Setelah aktif, tekan Generate
        ulang. Kalau tetap gagal, cek juga{" "}
        <a
          href="/profile"
          className="underline underline-offset-2"
          onClick={onClose}
        >
          halaman Profil
        </a>{" "}
        untuk memastikan API key masih terhubung ke project yang sama.
      </p>
    </div>
  );
}
